import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { DataProvider } from "./Datacontext";
import { store, persistedStore } from "./components/auth/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistedStore}>
      <DataProvider>
        <Router>
          <App />
        </Router>
      </DataProvider>
    </PersistGate>
  </Provider>
);
